<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <edit-form ref="editForm" :receiveLineCode="params.receiveLineCode" />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'openapi-iyeed-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
